import { reactive } from 'vue';
import { IInlineSearchState } from '@/interfaces/state.interface';
import TabsKind from '@/enums/tabs.enum';

const state: IInlineSearchState = reactive({
	amIVisible: false,
	text: '',
	results: {
		[TabsKind.PROGRAMMES]: null,
	},
	tabs: [
		{
			id: TabsKind.PROGRAMMES,
			title: 'Programmes',
			amount: 0,
		},
		{
			id: TabsKind.SEARCHING_FOR,
			title: 'Programmes',
			label: 'Searching',
			exclusive: true,
		}
	],
	selectedTab: TabsKind.SEARCHING_FOR,
	userData: {
		currency: 'EUR',
	},
	suggestions: null,
	facets: null,
	isGAIQuestionnaireTaken: false,
	dependenciesReady: false,
	programmeSearchInput: null,
	filterProvider: null,
	userKeyboardEvent: null,
});

export default state;